import React from 'react';
import { useTheme } from '../../context/ThemeContext';

const AppearanceSection = ({ settings, onChange }) => {
  const { isDarkMode, toggleTheme, isSidebarExpanded, toggleSidebar } = useTheme();

  const handleThemeToggle = () => {
    toggleTheme();
    onChange('appearance.theme', isDarkMode ? 'light' : 'dark');
  };

  const handleSidebarToggle = () => {
    toggleSidebar();
    onChange('appearance.sidebarExpanded', !isSidebarExpanded);
  };

  return (
    <div className="settings-card">
      <div className="settings-card-header">
        <i className="bi bi-palette" />
        Appearance
      </div>

      <div className="settings-row">
        <div className="settings-row-info">
          <span className="settings-row-label">Theme</span>
          <span className="settings-row-help">Switch between dark and light mode</span>
        </div>
        <div className="settings-row-control">
          <button
            className={`settings-toggle${isDarkMode ? ' active' : ''}`}
            onClick={handleThemeToggle}
            aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
          >
            <span className="settings-toggle-knob" />
          </button>
        </div>
      </div>

      <div className="settings-row">
        <div className="settings-row-info">
          <span className="settings-row-label">Sidebar Expanded</span>
          <span className="settings-row-help">Default sidebar state on load</span>
        </div>
        <div className="settings-row-control">
          <button
            className={`settings-toggle${isSidebarExpanded ? ' active' : ''}`}
            onClick={handleSidebarToggle}
            aria-label="Toggle sidebar expanded"
          >
            <span className="settings-toggle-knob" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppearanceSection;
